module.exports = __webpack_public_path__ + "sl.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/sl.svg
// module id = 1062
// module chunks = 0